import { vec } from "excalibur";
import { Config } from "./config";
import Dialog from "./ui/dialog";

export default class CutSceneManager {
  constructor(items, char1, char2, endScene) {
    this.items = items;
    this.action = 0;
    this.moveFunction = char1.moveFunction;
    this.char1 = char1;
    this.char1.cutScene = true;
    this.endScene = endScene;
  }
  move(action) {
    console.log("cutscene: inside move: ", this.items);
    switch (action.direction) {
      case "left":
        this.char1.actions
          .callMethod(() => {
            this.char1.graphic = "left-walk";
          })
          .moveBy(vec(-action.content, 0), 20)
          .callMethod(() => {
            this.char1.graphic = "left-idle";
          })
          .delay(500)
          .callMethod(() => {
            this.nextAction();
          });
        break;
      case "right":
        this.char1.actions
          .callMethod(() => {
            this.char1.graphic = "right-walk";
          })
          .moveBy(vec(action.content, 0), 20)
          .callMethod(() => {
            this.char1.graphic = "right-idle";
          })
          .delay(500)
          .callMethod(() => {
            this.nextAction();
          });
        break;
      case "up":
        this.char1.actions
          .callMethod(() => {
            this.char1.graphic = "up-walk";
          })
          .moveBy(vec(0, -action.content), 20)
          .callMethod(() => {
            this.char1.graphic = "idle-up";
          })
          .delay(500)
          .callMethod(() => {
            this.nextAction();
          });
        break;
      case "down":
        this.char1.actions
          .callMethod(() => {
            this.char1.graphic = "down-walk";
          })
          .moveBy(vec(0, action.content), 20)
          .callMethod(() => {
            this.char1.graphic = "idle-down";
          })
          .delay(500)
          .callMethod(() => {
            this.nextAction();
          });
        break;
      default:
        break;
    }
  }
  enterPress() {
    if (this.dialog) {
      this.dialog.enterPress();
    }
  }
  getItems() {
    return this.items;
  }
  getAction() {
    return this.action;
  }
  nextAction() {
    console.log("cutscene: inside nextAction: ", this.items);
    if (this.action == this.items.length - 1) {
      if (this.loop) {
        this.action = 0;
      } else {
        this.endScene();
        return;
      }
      this.startScene();
    } else {
      this.action++;
      this.startScene();
    }
  }
  startScene() {
    console.log(
      "cutscene:  started: ",
      this.items,
      " char1: ",
      this.char1,
      " first action: ",
      this.items[this.action]
    );
    if (this.items[this.action].action == "move") {
      console.log("cutscene: move");
      this.move(this.items[this.action]);
    } else if (this.items[this.action].action == "dialog") {
      this.dialog = new Dialog(
        this.items[this.action].content,
        () => {
          console.log("dialog ended");
          this.nextAction();
        },
        "grandpa",
        "bottom"
      );
    }
  }
}
